// extracted by mini-css-extract-plugin
export default {"link":"UserProfileAdministrationOnline_link__MPyN1","text":"UserProfileAdministrationOnline_text__Ktu8-"};